import { HapticsPlugin } from '@capacitor/haptics/dist/esm/definitions';

type HapticsModuleCompat =
  | typeof import('@capacitor/haptics')
  | typeof import('capacitor7-haptics');

export * from '@capacitor/haptics/dist/esm/definitions';
// We are intentionally using a mutable export so that we can mimic the original import
// syntax for Capacitor plugins, while still dynamically loading the correct capacitor version.
// Don't remove or try to fix the skipcq, as this syntax is mandatory for the compatibility bridge.
// skipcq: JS-E1009
export let Haptics: HapticsPlugin;

const load = (module: HapticsModuleCompat) => {
  Haptics = module.Haptics as HapticsPlugin;
};

export default load;
